<template>
  <v-container class="mt-n5 pt-n5">
    <v-row class="mt-0 pt-0 mb-0 pb-0">
      <v-col cols="12" md="8">
        <v-row>
          <v-col class="ma-4">
            Date de naissance :
            <b>{{ convertDateToString(candidature.etudiant.dateNaissance) }}</b
            ><br />
            Adresse : <b>{{ candidature.etudiant.addrNoRue }}</b
            ><br />
            <b
              >{{ candidature.etudiant.addrCp }}
              {{ candidature.etudiant.addrVille }}</b
            ><br />
            <b>{{ candidature.etudiant.addrPays }}</b>
            <template v-if="voirTypeEtudiant">
              <br />
              <span v-if="candidature.etudiant.uid">
                <v-icon :color="colorUnivLille">mdi-alpha-l-circle</v-icon
                >Étudiant interne
              </span>
              <span v-else>Étudiant externe</span>
            </template>
          </v-col>
          <v-col class="ma-4">
            INE/BEA : <b>{{ candidature.etudiant.ine }}</b
            ><br />
            Telephone : <b>{{ candidature.etudiant.telephone }}</b> <br />
            Mail : <b>{{ candidature.etudiant.mail }}</b>
            <v-row>
              <v-checkbox
                v-model="candidatureEtudiantPresenceAtelier"
                readonly
                label="Atelier"
              ></v-checkbox>
              <v-checkbox
                class="ml-5"
                v-model="candidatureEtudiantPresenceEntretien"
                readonly
                label="Entretien"
              ></v-checkbox>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-n6 pt-n6 mb-n6 pb-n6">
          <v-col>
            <v-card flat
              ><v-card-title>Cursus</v-card-title>
              <v-card-text>
                <v-col>
                  Baccalauréat :
                  <b
                    >{{ candidature.bacSerie }} obtenu en
                    {{ candidature.etudiant.anneeBac }}</b
                  ><br />
                  Cursus post-bac :<br />
                  <ul>
                    <li
                      v-for="item in candidature.etudiant.cursusPostBac"
                      :key="item.id"
                    >
                      {{ item.libelleAnneeUniv }} - {{ item.cursus }} -
                      {{ item.niveau }} -
                      <span v-if="item.validation">Obtenu</span>
                      <span v-else>Non obtenu</span> -
                      {{ item.etablissement }}
                    </li>
                  </ul>
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card flat
              ><v-card-title>Niveau et formation actuelle</v-card-title>
              <v-card-text>
                <v-col>
                  Niveau :
                  <b>{{ candidature.niveauFormation }}</b
                  ><br />
                  Intitulé :
                  <b>{{ candidature.etudiant.formationSemestre1 }}</b
                  ><br />
                  Etablissement :
                  <b>{{ candidature.etudiant.etabSemestre1 }}</b
                  ><br />
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row
          v-if="
            candidature.etatDemande.id == ETAT.REFUSEE.code ||
            candidature.etatDemande.id == ETAT.NON_VALIDE.code
          "
          class="mt-n6 pt-n6 mb-n6 pb-n6"
        >
          <v-col>
            <v-card flat>
              <v-card-title>Motif du refus</v-card-title>
              <v-card-text>
                <v-textarea
                  name="decision"
                  :value="candidature.motifRefus"
                  rows="2"
                  readonly
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <span class="font-weight-light">État de la demande: </span
            ><br /><span class="elevation-5">{{
              candidature.etatDemande.libelle
            }}</span>
          </v-col>
        </v-row>
        <a
          :href="urlArchive()"
          title="Télécharger le dossier complet de la candidature"
          >Télécharger le dossier complet de la candidature</a
        >
        <ListePiecesEtudiant
          :idEtudiant="candidature.etudiant.id"
          :idFormation="candidature.formation.id"
        ></ListePiecesEtudiant>
      </v-col>
    </v-row>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="primary--text">Voir l'historique de la candidature</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <HistoriqueCandidature
            :idCandidature="candidature.id"
          ></HistoriqueCandidature>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import ListePiecesEtudiant from "@/components/ListePiecesEtudiant";
import moment from "moment";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import HistoriqueCandidature from "@/components//HistoriqueCandidature.vue";

export default {
  name: "ResumeCandidature",
  props: {
    candidature: { type: Object, required: true },
    voirTypeEtudiant: { type: Boolean, required: false },
  },
  components: { ListePiecesEtudiant, HistoriqueCandidature },
  mixins: [EtatDemande],
  data() {
    return { loading: false, colorUnivLille: "#1f8388" };
  },
  methods: {
    urlArchive() {
      return (
        process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/fusionPdf/" +
        this.candidature.id
      );
    },
    convertDateToString(date) {
      return date ? moment(date).format("DD/MM/YYYY") : "";
    },
  },
  computed: {
    candidatureEtudiantPresenceAtelier() {
      return this.candidature.etudiant.presenceAtelier;
    },
    candidatureEtudiantPresenceEntretien() {
      return this.candidature.etudiant.presenceEntretien;
    },
  },
  async created() {},
};
</script>
